/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES 企業の管理画面用 API
 * PR TIMES 企業の管理画面で使うAPI。basePathは今後変わる事も想定している。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PressKitLogoExtensionEnum } from './PressKitLogoExtensionEnum';
import {
    PressKitLogoExtensionEnumFromJSON,
    PressKitLogoExtensionEnumFromJSONTyped,
    PressKitLogoExtensionEnumToJSON,
} from './PressKitLogoExtensionEnum';
import type { PressKitTag } from './PressKitTag';
import {
    PressKitTagFromJSON,
    PressKitTagFromJSONTyped,
    PressKitTagToJSON,
} from './PressKitTag';
import type { PressKitThumbnailUrls } from './PressKitThumbnailUrls';
import {
    PressKitThumbnailUrlsFromJSON,
    PressKitThumbnailUrlsFromJSONTyped,
    PressKitThumbnailUrlsToJSON,
} from './PressKitThumbnailUrls';

/**
 * プレスキットロゴの詳細
 * @export
 * @interface PressKitLogo
 */
export interface PressKitLogo {
    /**
     * PressKit Logo UUID(v4)
     * @type {string}
     * @memberof PressKitLogo
     */
    id: string;
    /**
     * ファイルリソースが保存されたS3のURL、https://prtimes-static-dev.s3.ap-northeast-1.amazonaws.com あるいは https://prtimes-static.s3.ap-northeast-1.amazonaws.com で始まることを検証している
     * @type {string}
     * @memberof PressKitLogo
     */
    resourceUri: string;
    /**
     * 企業が登録したファイルの名前（キャプション）
     * @type {string}
     * @memberof PressKitLogo
     */
    title: string;
    /**
     * 企業が登録したファイルの名前（title+extension）
     * @type {string}
     * @memberof PressKitLogo
     */
    filename: string;
    /**
     * 企業が登録したファイルの説明文。設定無しは''になる。
     * @type {string}
     * @memberof PressKitLogo
     */
    description: string;
    /**
     * 
     * @type {PressKitLogoExtensionEnum}
     * @memberof PressKitLogo
     */
    extension: PressKitLogoExtensionEnum;
    /**
     * ファイルのサイズ（単位はbytes）
     * @type {number}
     * @memberof PressKitLogo
     */
    fileSize: number;
    /**
     * ラスター画像の幅。単位はpx。ベクター画像はnull。
     * @type {number}
     * @memberof PressKitLogo
     */
    width?: number;
    /**
     * ラスター画像の高さ。単位はpx。ベクター画像はnull。
     * @type {number}
     * @memberof PressKitLogo
     */
    height?: number;
    /**
     * 
     * @type {PressKitThumbnailUrls}
     * @memberof PressKitLogo
     */
    thumbnailUrls: PressKitThumbnailUrls;
    /**
     * 画像のダウンロード用URL。別ドメイン。
     * @type {string}
     * @memberof PressKitLogo
     */
    downloadUrl: string;
    /**
     * 設定されているタグ一覧
     * @type {Array<PressKitTag>}
     * @memberof PressKitLogo
     */
    tags: Array<PressKitTag>;
}

/**
 * Check if a given object implements the PressKitLogo interface.
 */
export function instanceOfPressKitLogo(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "resourceUri" in value;
    isInstance = isInstance && "title" in value;
    isInstance = isInstance && "filename" in value;
    isInstance = isInstance && "description" in value;
    isInstance = isInstance && "extension" in value;
    isInstance = isInstance && "fileSize" in value;
    isInstance = isInstance && "thumbnailUrls" in value;
    isInstance = isInstance && "downloadUrl" in value;
    isInstance = isInstance && "tags" in value;

    return isInstance;
}

export function PressKitLogoFromJSON(json: any): PressKitLogo {
    return PressKitLogoFromJSONTyped(json, false);
}

export function PressKitLogoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PressKitLogo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'resourceUri': json['resource_uri'],
        'title': json['title'],
        'filename': json['filename'],
        'description': json['description'],
        'extension': PressKitLogoExtensionEnumFromJSON(json['extension']),
        'fileSize': json['file_size'],
        'width': !exists(json, 'width') ? undefined : json['width'],
        'height': !exists(json, 'height') ? undefined : json['height'],
        'thumbnailUrls': PressKitThumbnailUrlsFromJSON(json['thumbnail_urls']),
        'downloadUrl': json['download_url'],
        'tags': ((json['tags'] as Array<any>).map(PressKitTagFromJSON)),
    };
}

export function PressKitLogoToJSON(value?: PressKitLogo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'resource_uri': value.resourceUri,
        'title': value.title,
        'filename': value.filename,
        'description': value.description,
        'extension': PressKitLogoExtensionEnumToJSON(value.extension),
        'file_size': value.fileSize,
        'width': value.width,
        'height': value.height,
        'thumbnail_urls': PressKitThumbnailUrlsToJSON(value.thumbnailUrls),
        'download_url': value.downloadUrl,
        'tags': ((value.tags as Array<any>).map(PressKitTagToJSON)),
    };
}

